/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './requestEmailConfirmation.defs.js'
export * as $defs from './requestEmailConfirmation.defs.js'
